import React, { useState, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom'
import styles from './SideMenu.module.scss'
import { getBackend } from '../../lib/icp'
import MenuItems from '../menuItems'

import pages, { generateUrl } from '../../pages'

interface IFocus {
  userName: string
  id: string
  imgUrl: string
  [propName: string]: string | any
}

const SideMenu = (props: any) => {
  const history = useHistory()

  const [currentUrl, setCurrentUrl] = useState<string | null>(null)
  const [focusUser, setFocusUser] = useState<any>([])

  const get_information = async () => {
    // const backend = await getBackend()
    // const user_list = await backend.getSubscriptionsUser()
    // setFocusUser(user_list)
  }

  const showTips = () => {
    props.showTips()
  }

  return (
    <>
      <div className={styles.side_wrap}>
        <MenuItems showTips={showTips} />
        <div className={styles.following_wrap}>
          {focusUser && focusUser.length > 0 && (
            <h1 className={styles.following_title}>Following</h1>
          )}
          <ul className={styles.following_ul}>
            {focusUser &&
              focusUser.length > 0 &&
              focusUser.map((item: any) => {
                return (
                  <li key={item.id}>
                    <Link
                      to={generateUrl(pages.channel.path, {
                        userName: item.userName,
                      })}
                    >
                      <img src={item.imgUrl} alt="" />
                    </Link>

                    <div className={styles.following_username}>
                      {item.userName}
                    </div>
                  </li>
                )
              })}
          </ul>
          {focusUser && focusUser.length > 6 && (
            <div className={styles.fol_bottom}>
              <div className={styles.fol_arrow}></div>
              <div>Show more</div>
            </div>
          )}
        </div>
      </div>
      <div className={styles.side_wrap_phone}></div>
    </>
  )
}

export default SideMenu
